/** @file Skins panel registration: skin list, default skin, duplicate, and each skin's entries. */
import { rigPanel } from '../rigKit/rigPanel';
import { SkinsView } from './SkinsView';

/** Rig panel over skin.*. */
export const panel = rigPanel('skins', 'panels.skins.title', SkinsView);
